import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { MYACCOUNTPAGE } from "npmlinks-constants";
import { getCardLogoType } from "../../utils";

const { ACCOUNT_SAVED_CARDS } = MYACCOUNTPAGE;

@inject("MyAccountStore")
@observer
class SavedCardBlock extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { cardDetails, onDelete } = this.props;
    return (
      <div className="nw-savedcard-block-details">
        <div className="nw-savedcard-block-data">
          <div className="nw-savedcard-block-name">{cardDetails.cardname}</div>
          <div className="nw-savedcard-block-name">
            <div className="nw-savedcard-block-title">
              {" "}
              {ACCOUNT_SAVED_CARDS.CARD_NUMBER}{" "}
            </div>
            {cardDetails.cardMorphedNumber}
          </div>
          <div className="nw-savedcard-logo">
            <div className="nw-savedcard-validity">
              <div className="nw-savedcard-block-title">
                {" "}
                {ACCOUNT_SAVED_CARDS.VALID}{" "}
              </div>
              {cardDetails.expMonth} / {cardDetails.expYear}
            </div>
            <div>
              <div
                className={`nw-creditcardnumber-input nw-creditcard-input nw-savedcard-logo-width
              ${getCardLogoType(cardDetails)}`}
              />
            </div>
          </div>
        </div>
        <div
          className="nw-savedcard-block-delete-btn"
          onClick={() => onDelete(cardDetails)}
        >
          {ACCOUNT_SAVED_CARDS.REMOVE_BUTTON}
        </div>
      </div>
    );
  }
}

SavedCardBlock.defaultProps = {
  cardDetails: {},
};

SavedCardBlock.wrappedComponent.propTypes = {
  cardDetails: PropTypes.shape({}),
  onDelete: PropTypes.func.isRequired,
};

const getFinalComponent = component =>
  inject("MyAccountStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SavedCardBlock.wrappedComponent,
  component: SavedCardBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/SavedCardBlock/index.js